// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pages {
    transition: width 0.3s linear;
    width: 100%;
    padding-block-start: 40px;
    padding-bottom: 0px;
    height: calc(100vh - 50px);
    overflow-x: hidden;
    scrollbar-width: thin;
}

.sidebar .sidebar-open .pages {
    padding-left: 40px;
}

.iframe-panels {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 20px;
    margin-top: 20px;
    padding: 5px;
}

@media (max-width: 768px) {
    .iframe-panels {
        grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
        gap: 15px;
    }
}

@media (max-width: 480px) {
    .iframe-panels {
        grid-template-columns: 1fr;
    }
}

.css-1978mzo-canvas-content {
    display: flex;
    flex-direction: column;
    padding: 16px;
    flex-basis: 100%;
    flex-grow: 1;
    overflow: hidden !important;
}

.device-panel {
    background: #ffffff;
    border: 1px solid #ccc;
    display: flex;
    flex: auto;
    height: 400px;
    border-radius: 20px;
    flex-direction: column;
}

@media (max-width: 768px) {
    .device-panel {
        height: 350px;
    }
}

.device-panel h6 {
    margin-bottom: 10px;
    font-weight: 600;
    text-align: center;
}

.device-panel iframe {
    flex-grow: 1;
    width: 100%;
    height: 100%;
    border: none;
}

.row {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

@media (max-width: 768px) {
    .row {
        flex-direction: column;
        gap: 15px;
    }
}

.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
    padding-right: 32px;
    color: black !important;
}

.css-hfutr2-MuiSvgIcon-root-MuiSelect-icon {
    color: black !important;
}

.panel {
    background: white;
    height: 100%;
    border-radius: 5px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    margin-left: 20px;
}

@media (max-width: 768px) {
    .panel {
        margin-left: 0;
        margin-bottom: 15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/Pages/Andon-Dashboard/andondasboard.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI;QACI,2DAA2D;QAC3D,SAAS;IACb;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAEhB,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,yCAAyC;IACzC,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,mBAAmB;IACvB;AACJ","sourcesContent":[".pages {\n    transition: width 0.3s linear;\n    width: 100%;\n    padding-block-start: 40px;\n    padding-bottom: 0px;\n    height: calc(100vh - 50px);\n    overflow-x: hidden;\n    scrollbar-width: thin;\n}\n\n.sidebar .sidebar-open .pages {\n    padding-left: 40px;\n}\n\n.iframe-panels {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n    gap: 20px;\n    margin-top: 20px;\n    padding: 5px;\n}\n\n@media (max-width: 768px) {\n    .iframe-panels {\n        grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n        gap: 15px;\n    }\n}\n\n@media (max-width: 480px) {\n    .iframe-panels {\n        grid-template-columns: 1fr;\n    }\n}\n\n.css-1978mzo-canvas-content {\n    display: flex;\n    flex-direction: column;\n    padding: 16px;\n    flex-basis: 100%;\n    -webkit-box-flex: 1;\n    flex-grow: 1;\n    overflow: hidden !important;\n}\n\n.device-panel {\n    background: #ffffff;\n    border: 1px solid #ccc;\n    display: flex;\n    flex: auto;\n    height: 400px;\n    border-radius: 20px;\n    flex-direction: column;\n}\n\n@media (max-width: 768px) {\n    .device-panel {\n        height: 350px;\n    }\n}\n\n.device-panel h6 {\n    margin-bottom: 10px;\n    font-weight: 600;\n    text-align: center;\n}\n\n.device-panel iframe {\n    flex-grow: 1;\n    width: 100%;\n    height: 100%;\n    border: none;\n}\n\n.row {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n}\n\n@media (max-width: 768px) {\n    .row {\n        flex-direction: column;\n        gap: 15px;\n    }\n}\n\n.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {\n    padding-right: 32px;\n    color: black !important;\n}\n\n.css-hfutr2-MuiSvgIcon-root-MuiSelect-icon {\n    color: black !important;\n}\n\n.panel {\n    background: white;\n    height: 100%;\n    border-radius: 5px;\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n    margin-left: 20px;\n}\n\n@media (max-width: 768px) {\n    .panel {\n        margin-left: 0;\n        margin-bottom: 15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
